(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter')
    .component('pdfprintersearch', {
      restrict: 'E',
      bindings: {
        pdfprinter: '<',
        pdfprinterref: '<',
        parentsave: '&?',
        editinplace: '@?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showpdfprinter($item, $model, $label)"
                   uib-typeahead="pdfprinter as pdfprinter.text for pdfprinter in vm.getPdfprinters($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-remove"></i> Keine SV gefunden
          <span class="btn btn-success" ng-click="vm.addPdfprinter()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>
          <span ng-click="vm.addPdfprinter()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true">
          <pdfprintereditor pdfprinter="vm.pdfprinter"></pdfprintereditor>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Pdfprinter', 'PdfprinterHelper',
        function ($log, Pdfprinter, PdfprinterHelper) {
          let vm = this;
          vm.save = save;
          vm.showpdfprinter = showpdfprinter;

          vm.getPdfprinters = getPdfprinters;
          // vm.addPdfprinter = PdfprinterHelper.addPdfprinter;
          vm.addPdfprinter = addPdfprinter;
          vm.editPdfprinter = PdfprinterHelper.editPdfprinter;

          vm.$onInit = function () {
            vm.newpdfprinter = {};

            if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
              vm.editinplace = true;
            }

            $log.debug('debug - editinplace', vm.editinplace);


            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }
            vm.lastpdfprinter = angular.copy(vm.pdfprinterresult);
            vm.lastpdfprinterref = angular.copy(vm.pdfprinterref);
          };

          function addPdfprinter() {
            $log.debug('debug - pdfprintersearch addPdfprinter called');
            PdfprinterHelper.addPdfprinter(function (pdfprinter) {
              $log.debug('debug: handle newly create pdfprinter');
              vm.pdfprinter = {};
              vm.pdfprinter.name = pdfprinter.name;
              vm.pdfprinter.short = pdfprinter.short;
              vm.pdfprinter._id = pdfprinter._id;
              vm.pdfprinterref = pdfprinter._id;
              vm.asyncSelected = pdfprinter.short;
              vm.parentsave({pdfprinter: vm.pdfprinter, pdfprinterref: vm.pdfprinterref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead pdfprinter search backend query
          function getPdfprinters(val) {
            // return Pdfprinterahead.$search({query: val}).$asPromise().then(function (response) {
            return Pdfprinter.$searchahead({query: val}).$asPromise().then(function (response) {
              return response.map(function (pdfprinter) {
                pdfprinter.text = pdfprinter.short;
                delete vm.error;
                return pdfprinter;
              });
            });
          }

          // typeahead pdfprinter search action
          function showpdfprinter($item, $model, $label) {
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            vm.pdfprinter = $model;
            vm.pdfprinterref = $model._id;
            delete vm.asyncSelected;
            vm.editinplace = true;
            $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === true) {
              vm.pdfprinter = $model;
              vm.pdfprinterref = $model._id;
              $log.debug('debug - pdfprintersearch editinplace');
            }
            else {
              vm.pdfprinter = {};
              vm.pdfprinter.name = $model.name;
              vm.pdfprinter.short = $model.short;
              vm.pdfprinter._id = $model._id;
              vm.pdfprinterref = $model._id;
              vm.parentsave({pdfprinter: vm.pdfprinter, pdfprinterref: vm.pdfprinterref});
              $log.debug('debug - pdfprintersearch do not  editinplace', vm.parentsave);
            }
          }

          function save() {
            if (!angular.equals(vm.pdfprinter, vm.lastpdfprinter) || !angular.equals(vm.pdfprinterref, vm.lastpdfprinterref)) {
              vm.lastpdfprinter = angular.copy(vm.pdfprinter);
              vm.lastpdfprinterref = angular.copy(vm.pdfprinterref);
              vm.parentsave({pdfprinter: vm.pdfprinter, pdfprinterref: vm.pdfprinterref});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());
